export const env = {
  // Build
  NG_APP_BUILD_ID: "20261031071236-81419da7",

  // Mission Configuration
  NG_APP_MISSION_ID: "italia",
  NG_APP_MISSION_NAME: "MMM Italia",
  NG_APP_APP_TYPE: "iglesia",
  
  // Firebase Configuration
  NG_APP_FIREBASE_API_KEY: "AIzaSyAXETWslJm7HEZwct37m6KR3wd1jr8pQP0",
  NG_APP_FIREBASE_AUTH_DOMAIN: "instalar-410501.firebaseapp.com",
  NG_APP_FIREBASE_PROJECT_ID: "instalar-410501",
  NG_APP_FIREBASE_STORAGE_BUCKET: "instalar-410501.firebasestorage.app",
  NG_APP_FIREBASE_MESSAGING_SENDER_ID: "969870693857",
  NG_APP_FIREBASE_APP_ID: "1:969870693857:web:402fd8015e44ac23922ea0",
  NG_APP_FIREBASE_MEASUREMENT_ID: "G-XXXXXXX",
  NG_APP_FUNCTIONS_REGION: "us-central1"
} as const;